<div class="folders-list container">
  <h1 class="header">{{ 'EFoldersUcpList.FoldersList' | translate }}</h1>

  <div class="content">
    <div #filters class="content-card filters">
      <div class="top">
        <div class="top__left">
          <button mat-raised-button color="accent" [matMenuTriggerFor]="menu">{{ 'EFoldersUcpList.MultipleActions' | translate }}</button>
          <mat-menu #menu="matMenu">
            <button
              mat-menu-item
              (click)="signSelected()"
              [disabled]="!isSignSelectedEnabled()"
              [matTooltip]="'EFoldersUcpList.SignTooltip' | translate"
              >
              <span>{{ 'EFoldersUcpList.Sign' | translate }}</span>
            </button>
            <button
              mat-menu-item
              (click)="exportSelected()"
              [disabled]="!isExportSelectedEnabled()"
              [matTooltip]="'EFoldersUcpList.ExportTooltip' | translate"
              >
              <span>{{ 'EFoldersUcpList.Export' | translate }} </span>
            </button>
            <button
              mat-menu-item
              (click)="deleteAndRecalculateSelected()"
              [disabled]="!isDeleteAndRecalculateSelectedEnabled()"
              [matTooltip]="'EFoldersUcpList.DeleteAndRecalculateNumerationTooltip' | translate"
              >
              <span>{{ 'EFoldersUcpList.DeleteAndRecalculateNumeration' | translate }} </span>
            </button>
            <button
              mat-menu-item
              (click)="deleteSelected()"
              [disabled]="!isDeleteSelectedEnabled()"
              [matTooltip]="'EFoldersUcpList.DeleteEFolderTooltip' | translate"
              >
              <span>{{ 'EFoldersUcpList.DeleteEFolder' | translate }} </span>
            </button>
          </mat-menu>
          <button mat-raised-button color="primary" class="add-document" (click)="openModal()">
            <span>{{ 'EFoldersUcpList.AddDocument' | translate }}</span>
          </button>
        </div>
        <div class="top__right">
          @if (showFilterPresetSelector) {
            <mat-form-field [@inOutAnimation] appearance="outline" class="filter-preset-selector">
              <mat-label>Filtr</mat-label>
              <mat-select [value]="selectedFilterPresetId" (valueChange)="setSelectedFilterPresetId($event)">
                @for (preset of filterPresets; track preset) {
                  <mat-option [value]="preset.Id">{{
                    preset.Name === defaultFilterPresetName ? ('DefaultFilterPresetName' | translate) : preset.Name
                  }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          <button (click)="resetFilters()" class="top__button top__button-clear">
            <mat-icon>close</mat-icon>
            {{ 'Reset' | translate }}
          </button>
          <button (click)="toggleFiltersPanel()" class="top__button top__button-filter">
            <mat-icon>filter_alt</mat-icon>
            {{ 'Filter' | translate }}
          </button>
        </div>
      </div>
      @if (areFiltersExpanded) {
        <app-e-folders-list-filters [formGroup]="filtersFormGroup" (filterGridData)="filterData($event)">
          <div class="favorite-button-row-container">
            <button (click)="saveFilterPresetButtonClick()" class="favorite-button">
              @if (isSavedFilterPreset) {
                <mat-icon>bookmark</mat-icon>
                {{ 'UnsaveFilter' | translate }}
              } @else {
                <mat-icon>bookmark_border</mat-icon>
                {{ 'SaveFilter' | translate }}
              }
            </button>
          </div>
        </app-e-folders-list-filters>
      }
    </div>

    <div class="content-card" [ngClass]="{ 'filters-opened': areFiltersExpanded }">
      <div #tableContainer class="wrapper custom-table">
        <cdk-virtual-scroll-viewport gridTableVirtualScroll (scrolledIndexChange)="nextBatch($event)">
          <mat-table
            class="table"
            matSort
            [matSortActive]="defaultSortColumn"
            [matSortDirection]="defaultSortDirection"
            matSortDisableClear
            [dataSource]="dataSource"
            (matSortChange)="onSortChange()"
            >
            <ng-container matColumnDef="select">
              <mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  appearance="outline"
                  (change)="onSelectAllChxChange()"
                  [checked]="dataSource.selection.hasValue() && isAllSelected()"
                  [indeterminate]="dataSource.selection.hasValue() && !isAllSelected()"
                  [matTooltip]="'SelectAll' | translate"
                  matTooltipPosition="above"
                  >
                </mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="onRowChxChange($event, row)"
                  [checked]="dataSource.selection.isSelected(row)"
                  >
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="FullName">
              <mat-header-cell *matHeaderCellDef mat-sort-header="LastName" class="hidden-sort">
                {{ 'EFoldersUcpList.FullName' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element">
                <a
                  class="user"
                  [routerLink]="['/profile/' + element.WorkerId]"
                  [matTooltip]="'WL-ShowWokerProfile' | translate"
                  matTooltipPosition="above"
                  >{{ element.LastName + ' ' + element.FirstName }}
                </a>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Pesel">
              <mat-header-cell *matHeaderCellDef mat-sort-header="DateOfBirth" class="hidden-sort">
                {{ 'EFoldersUcpList.Pesel' | translate }}
                <app-table-header-sort></app-table-header-sort>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                ><span [matTooltip]="element.Pesel">{{ element.Pesel }}</span></mat-cell
                >
              </ng-container>

              <ng-container matColumnDef="Document">
                <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                  {{ 'EFoldersUcpList.Document' | translate }}
                  <app-table-header-sort></app-table-header-sort>
                </mat-header-cell>
                <mat-cell *matCellDef="let element"
                  ><span [matTooltip]="element.Document">{{ element.DocumentType }}</span></mat-cell
                  >
                </ng-container>

                <ng-container matColumnDef="ValidUntilDateFrom">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'EFoldersUcpList.ValidUntilDateFrom' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span [matTooltip]="element.ValidUntilDateFromTooltip">{{ element.ValidUntilDateFrom | date : 'yyyy-MM-dd' }}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="ValidUntilDateTo">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'EFoldersUcpList.ValidUntilDateTo' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span [matTooltip]="element.ValidUntilDateToTooltip">{{ element.ValidUntilDateTo | date : 'yyyy-MM-dd' }}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="AddedDate">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'EFoldersUcpList.AddedDate' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span [matTooltip]="element.AddedDateTooltip">{{ element.AddedDate | date : 'yyyy-MM-dd' }}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Comments">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
                    {{ 'EFoldersUcpList.Comments' | translate }}
                    <app-table-header-sort></app-table-header-sort>
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <span [matTooltip]="element.Comments">{{ element.Comments }}</span>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="Actions">
                  <mat-header-cell *matHeaderCellDef>{{ 'EFoldersUcpList.Actions' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <div fxLayout="row">
                      <button
                        mat-icon-button
                        (click)="onPreviewBtnClick(element)"
                        [matTooltip]="'EFoldersUcpList.PreviewTooltip' | translate"
                        matTooltipPosition="above"
                        >
                        <mat-icon class="material-icons-outlined">visibility</mat-icon>
                      </button>

                      <button
                        mat-icon-button
                        (click)="onEditBtnClick(element)"
                        [matTooltip]="'EFoldersUcpList.EditTooltip' | translate"
                        matTooltipPosition="above"
                        >
                        <mat-icon class="material-icons-outlined">create</mat-icon>
                      </button>

                      <button
                        mat-icon-button
                        (click)="onPreviewFileBtnClick(element)"
                        [matTooltip]="'EFoldersUcpList.FilePreviewTooltip' | translate"
                        matTooltipPosition="above"
                        >
                        <mat-icon class="material-icons-outlined">note_add</mat-icon>
                      </button>

                      <button
                        mat-icon-button
                        (click)="onDownloadBtnClick(element)"
                        [matTooltip]="'EFoldersUcpList.FileDownloadTooltip' | translate"
                        matTooltipPosition="above"
                        >
                        <mat-icon class="material-icons-outlined">file_download</mat-icon>
                      </button>

                      <button
                        mat-icon-button
                        (click)="onSendBtnClick(element)"
                        [matTooltip]="'EFoldersUcpList.ExportTooltip' | translate"
                        matTooltipPosition="above"
                        >
                        <mat-icon class="material-icons-outlined">arrow_right_alt</mat-icon>
                      </button>
                    </div>
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="progress">
                  <mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                    <mat-progress-bar [mode]="dataSource.isLoading ? 'indeterminate' : 'determinate'" class="table-progress" color="accent">
                    </mat-progress-bar>
                  </mat-header-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns; sticky: sticky" [style.top.px]="offset$ | async"></mat-header-row>
                <mat-header-row *matHeaderRowDef="['progress']; sticky: sticky" class="progress" [style.top.px]="(offset$ | async) + 56">
                </mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
              </mat-table>
            </cdk-virtual-scroll-viewport>
          </div>
        </div>
        <app-item-counter class="item-counter" [position]="scrollItemPosition" [length]="dataSource.absoluteDataLength"></app-item-counter>
      </div>
    </div>
